//reducers
import { configureStore } from "@reduxjs/toolkit";
import SurveySlice from "./slice/SurveySlice/SurveySlice";
import AnswersSlice from "./slice/SurveySlice/AnswerSlice";
import LanguageSlice from "./slice/LanguageSlice/LanguageSlice";
import { ImageStoreSlice } from "./slice/SurveySlice/ImageStoreSlice";

export const store = configureStore({
  reducer: { Survey: SurveySlice, Answers: AnswersSlice, ImageStore: ImageStoreSlice },
  LanguageSlice: LanguageSlice,
  devTools: true,
});
